function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _rect, _rect2, _path, _circle, _path2, _path3, _path4, _circle2, _path5;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
import { Platform } from 'react-native';
import { createElement } from 'react';
var SvgNewCustomerFirstVisit = function SvgNewCustomerFirstVisit(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    x: 4,
    y: 4,
    fill: "#D1FAE5",
    rx: 28
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 54,
    x: 34,
    y: 34,
    fill: "#FFF",
    stroke: "#047857",
    strokeWidth: 3,
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ECFDF5",
    stroke: "#047857",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m74 34 16 7v47l-16-7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 62,
    r: 3,
    fill: "#047857"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#10B981",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M28 92h64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#10B981",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M44 92v-6h20v6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F59E0B",
    d: "M92 30c-5 0-9 4-9 9 0 7 9 14 9 14s9-7 9-14c0-5-4-9-9-9z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 39,
    r: 3,
    fill: "#FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#34D399",
    d: "m24 38 2 4 4 2-4 2-2 4-2-4-4-2 4-2z"
  })));
};
if (Platform.OS === 'web') {
  var ForwardRefNativeSvgIcon = /*#__PURE__*/React.forwardRef(SvgNewCustomerFirstVisit);
  SvgNewCustomerFirstVisit = function SvgNewCustomerFirstVisit(props, ref) {
    return /*#__PURE__*/createElement(ForwardRefNativeSvgIcon, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    }));
  };
}
var ForwardRef = /*#__PURE__*/forwardRef(SvgNewCustomerFirstVisit);
export default ForwardRef;